/*
 * dates reducer
 */
import { RESET_STATE } from '../auth/constants';
import SET_HASH from './constants';

type State = {};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state?: State = initialState, action?: Action) {
    if (!action) return state;
    switch (action.type) {
        case SET_HASH:
            return {
                ...state,
                [action.payload.namespace]: action.payload.date
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
